import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import * as validators from 'utils/validators';
import InputField from 'components/InputField';
import { connect } from 'react-redux';
import * as actions from 'modules/account';
import { injectIntl } from 'react-intl';
import RichField from 'components/RichField';
import ConfirmForm from './ConfirmForm';
import CollapsablePanel from './CollapsePanel';
import EmailTranslations from './EmailTranslations';
import ClientsTableConfigurations from './ClientsTableConfigurations';
import ShippyProConfigurations from './ShippyProConfigurations';
import SupportWidget from '../pages/SupportWidget';
import { canUseFeature } from '../../config/pricing';

class ProfileForm extends ConfirmForm {
    constructor(props) {
        super(props);
        this.state = {
            testingGoogle: false,
            testingFtp: false,
            testingSmtp: false,
            googleResult: null,
            ftpResult: null,
            smtpResult: null,
        };
    }

    testGoogleDrive() {
        this.setState({ testingGoogle: true, googleResult: null });
        this.props.dispatch(actions.testGoogleDrive()).then(result => {
            this.setState({ testingGoogle: false, googleResult: result });
        }).catch(() => {
            this.setState({ testingGoogle: false, googleResult: { success: false, error: 'Request failed' } });
        });
    }

    testFtp() {
        let { notifications } = this.props;
        let ftp = notifications && notifications.ftp;
        if (!ftp) return;
        this.setState({ testingFtp: true, ftpResult: null });
        this.props.dispatch(actions.testFtp({
            host: ftp.host,
            port: ftp.port,
            user: ftp.user,
            password: ftp.password,
            secure: ftp.secure
        })).then(result => {
            this.setState({ testingFtp: false, ftpResult: result });
        }).catch(() => {
            this.setState({ testingFtp: false, ftpResult: { success: false, error: 'Request failed' } });
        });
    }

    testSmtp() {
        let { notifications } = this.props;
        let smtp = notifications && notifications.smtp;
        if (!smtp || !smtp.host || !smtp.user || !smtp.password) {
            this.setState({ smtpResult: { success: false, error: 'Please fill in all SMTP configuration fields first.' } });
            return;
        }
        this.setState({ testingSmtp: true, smtpResult: null });
        this.props.dispatch(actions.testSmtp({
            host: smtp.host,
            port: smtp.port,
            secure: smtp.secure,
            user: smtp.user,
            password: smtp.password,
            fromEmail: smtp.fromEmail,
            fromName: smtp.fromName
        })).then(result => {
            this.setState({ testingSmtp: false, smtpResult: result });
        }).catch(() => {
            this.setState({ testingSmtp: false, smtpResult: { success: false, error: 'Request failed' } });
        });
    }

    componentDidMount() {
        if (typeof window !== "undefined") {

            SupportWidget();

            let windowEl = (function () {
                var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                function scroll() {
                    return { left: scrollLeft, top: scrollTop };
                };
                function scrollLeft() {
                    return window.scrollX || window.pageXOffset || (isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft);
                };
                function scrollTop() {
                    return window.scrollY || window.pageYOffset || (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
                };
                return {
                    scroll: scroll,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                }
            })();

            let handle = setInterval(() => {
                let scrollY = windowEl.scrollTop();
                if (scrollY !== 0)
                    window && window.scrollTo(0, 0);
                else clearInterval(handle);

            }, 800);
        }
    }

    renderTestResult(result) {
        if (!result) return null;
        let style = {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            marginLeft: '12px',
            padding: '4px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: 500,
        };
        if (result.success) {
            style.background = '#ecfdf5';
            style.color = '#065f46';
        } else {
            style.background = '#fef2f2';
            style.color = '#991b1b';
        }
        return <span style={style}>
            <i className={`fa ${result.success ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
            {result.success ? result.message : result.error}
        </span>;
    }

    render() {
        let { initialValues, pristine, submitting, handleSubmit, onSubmit, google, notifications, profile, intl } = this.props;
        const t = (id) => intl.formatMessage({ id });
        if (!profile.shopify) {
            return <div></div>
        }
        initialValues.styles = initialValues.styles || {};

        let disabled = pristine || submitting || initialValues.reverting;
        let hasChanges = !disabled;
        let isFreePlan = profile.profile && profile.profile.subscription === 'free';
        let hasMultipleLocations = initialValues.hasMultipleLocations;

        const cardStyle = {
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius-lg)',
            padding: '24px',
            marginBottom: '16px',
            boxShadow: 'var(--shadow-sm)',
        };

        const cardTitleStyle = {
            fontSize: '16px',
            fontWeight: 600,
            color: 'var(--text-primary)',
            margin: '0 0 4px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
        };

        const cardDescStyle = {
            fontSize: '13px',
            color: 'var(--text-secondary)',
            margin: '0 0 16px 0',
            lineHeight: '1.5',
        };

        const iconBadgeStyle = (color) => ({
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            color: '#fff',
            background: color,
            flexShrink: 0,
        });

        const testBtnStyle = {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '7px 14px',
            fontSize: '12px',
            fontWeight: 500,
            borderRadius: '6px',
            border: '1px solid var(--primary)',
            background: 'transparent',
            color: 'var(--primary)',
            cursor: 'pointer',
            transition: 'all 150ms ease',
        };

        const upgradeBadge = <span style={{
            fontSize: '11px',
            fontWeight: 600,
            padding: '2px 8px',
            borderRadius: '4px',
            background: '#eef2ff',
            color: 'var(--primary)',
            marginLeft: '8px',
        }}>{t('delivery.pro')}</span>;

        const sectionDivider = <div style={{ borderTop: '1px solid var(--border)', margin: '12px 0' }}></div>;

        return (<div className="container-fluid">
            <style>{`
                .delivery-page textarea {
                    font-size: 11px;
                    font-family: 'SF Mono', Consolas, Monaco, 'Courier New', monospace;
                    background-color: #f8fafc;
                    border: 1px solid var(--border);
                    border-radius: var(--radius-md);
                    padding: 12px;
                    width: 100%;
                    resize: vertical;
                }
                .delivery-page .form-group { margin-bottom: 16px; }
                .delivery-page .form-group label { font-size: 13px; font-weight: 500; color: var(--text-primary); margin-bottom: 6px; display: block; }
                .delivery-page .checkbox { margin-left: 0; padding-left: 0; }
                .delivery-page .checkbox label { display: flex; align-items: center; gap: 8px; font-weight: 400; color: var(--text-primary); cursor: pointer; padding-left: 0; margin-bottom: 0; }
                .delivery-page .checkbox input[type="checkbox"] { position: static; margin: 0; margin-left: 0; }
                .delivery-page .form-control { border-radius: var(--radius-md); border: 1px solid var(--border); padding: 8px 12px; font-size: 13px; transition: border-color 150ms ease; }
                .delivery-page .form-control:focus { border-color: var(--primary); box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08); outline: none; }
            `}</style>

            {isFreePlan ? <div className="delivery-page">
                <div style={{...cardStyle, borderLeft: '4px solid var(--primary)'}}>
                    <h4 style={{margin: '0 0 8px', fontWeight: 600}}>{t('delivery.freePlanTitle')}</h4>
                    <p style={cardDescStyle}>{t('delivery.freePlanDesc')}</p>
                    <button className="btn btn-success" onClick={() => { window ? window.location.href = 'billing' : () => { } }}>{t('common.upgradePlan')}</button>
                </div>

                <div style={cardStyle}>
                    <h4 style={cardTitleStyle}>{t('delivery.emailLiquidTemplate')}</h4>
                    <p style={cardDescStyle}>{intl.formatMessage({ id: 'delivery.liquidTemplateDesc' }, { link: <a key="link" target="_blank" href={`https://${profile.shopify.shopName}.myshopify.com/admin/email_templates/order_confirmation/edit`}>{t('delivery.here')}</a> })}</p>
                    <textarea rows="5" readOnly value={`{% assign url = "https://invoicebrowse.growth-connections.com/order/${profile.shopify.shopName}/" | append: order.customer.id | append: "," | append: order.id | append: ",false/pdf" %}\n<a href="{{ url }}">Download your invoice </a>`} />
                </div>
            </div> :
                <div className="row delivery-page">
                    <form className="col-md-7 col-lg-6" onSubmit={handleSubmit(onSubmit)}>

                        {/* Warning banner for users with email autopilot but no SMTP */}
                        {notifications && notifications.email && notifications.email.autopilot &&
                         (!notifications.smtp || !notifications.smtp.host) && (
                            <div style={{
                                background: '#fef2f2',
                                border: '1px solid #fca5a5',
                                borderLeft: '4px solid #dc2626',
                                borderRadius: 'var(--radius-lg)',
                                padding: '16px 20px',
                                marginBottom: '20px',
                                display: 'flex',
                                alignItems: 'start',
                                gap: '12px'
                            }}>
                                <i className="fa fa-exclamation-triangle" style={{
                                    color: '#dc2626',
                                    fontSize: '20px',
                                    marginTop: '2px'
                                }}></i>
                                <div style={{ flex: 1 }}>
                                    <h4 style={{
                                        margin: '0 0 8px 0',
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#991b1b'
                                    }}>
                                        Action Required: Configure SMTP for Email Delivery
                                    </h4>
                                    <p style={{
                                        margin: '0 0 12px 0',
                                        fontSize: '13px',
                                        color: '#7f1d1d',
                                        lineHeight: '1.5'
                                    }}>
                                        You have automatic email delivery enabled, but no SMTP server is configured.
                                        Your invoices are <strong>not being emailed to customers</strong>. Please configure
                                        your SMTP settings below to resume email delivery.
                                    </p>
                                    <details style={{ fontSize: '13px', color: '#7f1d1d' }}>
                                        <summary style={{
                                            cursor: 'pointer',
                                            fontWeight: 500,
                                            marginBottom: '8px'
                                        }}>
                                            Why do I need SMTP?
                                        </summary>
                                        <p style={{ margin: '8px 0 0 0', lineHeight: '1.5' }}>
                                            We've upgraded our email delivery system to give you more control and better deliverability.
                                            You can use any SMTP provider like <strong>SendGrid</strong> (100 free emails/day),
                                            <strong>Mailgun</strong> (5,000 free/month), <strong>Amazon SES</strong> (very low cost),
                                            or even <strong>Gmail SMTP</strong> (free for low volume).
                                        </p>
                                    </details>
                                </div>
                            </div>
                        )}

                        <CollapsablePanel location="settings" section="settings" title={t('delivery.settings')}>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor="notifications.settings.useOrderNumber">
                                        <Field value="notifications.settings.useOrderNumber" name="notifications.settings.useOrderNumber" id="notifications.settings.useOrderNumber" component="input" type="checkbox" />{t('delivery.useOrderNumbers')}</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor="notifications.settings.onlyForCountryCode">
                                        <Field value="notifications.settings.onlyForCountryCode" name="notifications.settings.onlyForCountryCode" id="notifications.settings.onlyForCountryCode" component="input" type="checkbox" />{t('delivery.sendIfCountry')}</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <Field className="form-control" name="notifications.settings.codes" component={InputField} type="text" value="notifications.settings.codes" />
                                <small style={{color: 'var(--text-secondary)'}}>{t('delivery.countryCodesHint')}</small>
                            </div>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor="notifications.settings.onlyForCustomersWithTags">
                                        <Field value="notifications.settings.onlyForCustomersWithTags" name="notifications.settings.onlyForCustomersWithTags" id="notifications.settings.onlyForCustomersWithTags" component="input" type="checkbox" />{t('delivery.sendForTags')}</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <Field className="form-control" name="notifications.settings.tags" component={InputField} type="text" value="notifications.settings.tags" />
                                <small style={{color: 'var(--text-secondary)'}}>{t('delivery.tagsHint')}</small>
                            </div>
                        </CollapsablePanel>

                        {/* Email Section */}
                        <div style={cardStyle}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px'}}>
                                <span style={iconBadgeStyle('#4F46E5')}><i className="fa fa-envelope"></i></span>
                                <div>
                                    <h4 style={{...cardTitleStyle, marginBottom: 0}}>{t('delivery.emailDelivery')}</h4>
                                    <p style={{...cardDescStyle, margin: 0}}>{t('delivery.sendAsPdf')}</p>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor="notifications.email.autopilot">
                                        <Field value="notifications.email.autopilot" name="notifications.email.autopilot" id="notifications.email.autopilot" component="input" type="checkbox" />{t('delivery.autoSend')}</label>
                                </div>
                            </div>
                            {notifications && notifications.email && notifications.email.autopilot && <section>
                                <div className="form-group">
                                    <label htmlFor="notifications.email.subject">{t('delivery.subject')}</label>
                                    <Field className="form-control" name="notifications.email.subject" component={InputField} type="text" value="notifications.email.subject" validate={[validators.required]} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="notifications.email.template">{t('delivery.body')}</label>
                                    <Field name="notifications.email.template" component={RichField} showParameters={true} html={initialValues.notifications.email.template} />
                                </div>
                                {hasMultipleLocations && <FieldArray name="notifications.email.translations" component={EmailTranslations} />}
                                {canUseFeature(profile.profile.subscription, 'ublXml') && <div>
                                    {sectionDivider}
                                    <p style={{...cardDescStyle, fontWeight: 500, color: 'var(--text-primary)'}}>{t('delivery.xmlAttachments')}</p>
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <label htmlFor="notifications.email.includeUbl">
                                                <Field value="notifications.email.includeUbl" name="notifications.email.includeUbl" id="notifications.email.includeUbl" component="input" type="checkbox" />{t('delivery.attachUbl')}</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <label htmlFor="notifications.email.includeZugferd">
                                                <Field value="notifications.email.includeZugferd" name="notifications.email.includeZugferd" id="notifications.email.includeZugferd" component="input" type="checkbox" />{t('delivery.attachZugferd')}</label>
                                        </div>
                                    </div>
                                </div>}

                                {sectionDivider}
                                <p style={{...cardDescStyle, fontWeight: 500, color: 'var(--text-primary)', marginBottom: '12px'}}>{t('delivery.customSmtp')}</p>
                                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px'}}>
                                    <div className="form-group">
                                        <label>{t('delivery.smtpHost')}</label>
                                        <Field className="form-control" name="notifications.smtp.host" component={InputField} type="text" value="notifications.smtp.host" validate={[validators.required]} />
                                    </div>
                                    <div className="form-group">
                                        <label>{t('delivery.port')}</label>
                                        <Field className="form-control" name="notifications.smtp.port" component={InputField} type="number" value="notifications.smtp.port" validate={[validators.required]} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="checkbox">
                                        <label htmlFor="notifications.smtp.secure">
                                            <Field value="notifications.smtp.secure" name="notifications.smtp.secure" id="notifications.smtp.secure" component="input" type="checkbox" />{t('delivery.useSsl')}</label>
                                    </div>
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px'}}>
                                    <div className="form-group">
                                        <label>{t('delivery.username')}</label>
                                        <Field className="form-control" name="notifications.smtp.user" component={InputField} type="text" value="notifications.smtp.user" validate={[validators.required]} />
                                    </div>
                                    <div className="form-group">
                                        <label>{t('delivery.password')}</label>
                                        <Field className="form-control" name="notifications.smtp.password" component={InputField} type="password" value="notifications.smtp.password" validate={[validators.required]} />
                                    </div>
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px'}}>
                                    <div className="form-group">
                                        <label>{t('delivery.fromEmail')}</label>
                                        <Field className="form-control" name="notifications.smtp.fromEmail" component={InputField} type="email" value="notifications.smtp.fromEmail" />
                                    </div>
                                    <div className="form-group">
                                        <label>{t('delivery.fromName')}</label>
                                        <Field className="form-control" name="notifications.smtp.fromName" component={InputField} type="text" value="notifications.smtp.fromName" />
                                    </div>
                                </div>
                                <div className="form-group" style={{marginBottom: 0}}>
                                    <button type="button" style={testBtnStyle} disabled={this.state.testingSmtp} onClick={() => this.testSmtp()}>
                                        <i className="fa fa-paper-plane"></i>{this.state.testingSmtp ? t('delivery.sending') : t('delivery.sendTestEmail')}
                                    </button>
                                    {this.renderTestResult(this.state.smtpResult)}
                                </div>
                            </section>}
                        </div>

                        {/* Liquid Template */}
                        <div style={cardStyle}>
                            <h4 style={cardTitleStyle}><i className="fa fa-code" style={{color: 'var(--text-secondary)'}}></i> {t('delivery.shopifyLiquid')}</h4>
                            <p style={cardDescStyle}>{t('delivery.pasteInto')} <a target="_blank" href={`https://${profile.shopify.shopName}.myshopify.com/admin/email_templates/order_confirmation/edit`}>{t('delivery.orderConfirmation')}</a> {t('delivery.toAddLink')}</p>
                            <textarea rows="4" readOnly value={`{% assign url = "https://invoicebrowse.growth-connections.com/order/${profile.shopify.shopName}/" | append: order.customer.id | append: "," | append: order.id | append: ",false/pdf" %}\n<a href="{{ url }}">Download your invoice </a>`} />
                        </div>

                        {/* ClientsTablet */}
                        {hasMultipleLocations && <div style={cardStyle}>
                            <h4 style={cardTitleStyle}>{t('delivery.clientsTablet')} <a target="_blank" href="https://klienditahvel.ee/" style={{fontSize: '12px'}}><i className="fa fa-external-link"></i></a></h4>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor="notifications.clientstablet.autopilot">
                                        <Field value="notifications.clientstablet.autopilot" name="notifications.clientstablet.autopilot" id="notifications.clientstablet.autopilot" component="input" type="checkbox" />{t('delivery.clientsTabletDesc')}</label>
                                </div>
                            </div>
                            {notifications && notifications.clientstablet && notifications.clientstablet.autopilot &&
                                <FieldArray name="notifications.clientstablet.configurations" component={ClientsTableConfigurations} />
                            }
                        </div>}

                        {/* ShippyPro */}
                        {hasMultipleLocations && <div style={cardStyle}>
                            <h4 style={cardTitleStyle}>{t('delivery.shippyPro')} <a target="_blank" href="https://ShippyPro.com/" style={{fontSize: '12px'}}><i className="fa fa-external-link"></i></a></h4>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor="notifications.shippypro.autopilot">
                                        <Field value="notifications.shippypro.autopilot" name="notifications.shippypro.autopilot" id="notifications.shippypro.autopilot" component="input" type="checkbox" />{t('delivery.shippyProDesc')}</label>
                                </div>
                            </div>
                            {notifications && notifications.shippypro && notifications.shippypro.autopilot &&
                                <FieldArray name="notifications.shippypro.configurations" component={ShippyProConfigurations} />
                            }
                        </div>}

                        {/* FTP Section */}
                        {canUseFeature(profile.profile.subscription, 'ftpSync') ? <div style={cardStyle}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px'}}>
                                <span style={iconBadgeStyle('#059669')}><i className="fa fa-folder-open"></i></span>
                                <div>
                                    <h4 style={{...cardTitleStyle, marginBottom: 0}}>{t('delivery.ftpBackup')}</h4>
                                    <p style={{...cardDescStyle, margin: 0}}>{t('delivery.ftpDesc')}</p>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label htmlFor="notifications.ftp.autopilot">
                                        <Field value="notifications.ftp.autopilot" name="notifications.ftp.autopilot" id="notifications.ftp.autopilot" component="input" type="checkbox" />{t('delivery.enableFtp')}</label>
                                </div>
                            </div>
                            {notifications && notifications.ftp && notifications.ftp.autopilot && <section>
                                <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '12px'}}>
                                    <div className="form-group">
                                        <label>{t('delivery.host')}</label>
                                        <Field className="form-control" name="notifications.ftp.host" component={InputField} type="text" value="notifications.ftp.host" validate={[validators.required, validators.hostname]} />
                                    </div>
                                    <div className="form-group">
                                        <label>{t('delivery.port')}</label>
                                        <Field className="form-control" name="notifications.ftp.port" component={InputField} type="number" value="notifications.ftp.port" validate={[validators.required]} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="checkbox">
                                        <label htmlFor="notifications.ftp.secure">
                                            <Field value="notifications.ftp.secure" name="notifications.ftp.secure" id="notifications.ftp.secure" component="input" type="checkbox" />{t('delivery.useSftp')}</label>
                                    </div>
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px'}}>
                                    <div className="form-group">
                                        <label>{t('delivery.username')}</label>
                                        <Field className="form-control" name="notifications.ftp.user" component={InputField} type="text" value="notifications.ftp.user" validate={[validators.required]} />
                                    </div>
                                    <div className="form-group">
                                        <label>{t('delivery.password')}</label>
                                        <Field className="form-control" name="notifications.ftp.password" component={InputField} type="password" value="notifications.ftp.password" validate={[validators.required]} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>{t('delivery.destinationFolder')}</label>
                                    <Field className="form-control" name="notifications.ftp.dest" component={InputField} type="text" value="notifications.ftp.dest" />
                                </div>
                                {canUseFeature(profile.profile.subscription, 'ublXml') && <div>
                                    {sectionDivider}
                                    <p style={{...cardDescStyle, fontWeight: 500, color: 'var(--text-primary)'}}>{t('delivery.xmlFiles')}</p>
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <label htmlFor="notifications.ftp.includeUbl">
                                                <Field value="notifications.ftp.includeUbl" name="notifications.ftp.includeUbl" id="notifications.ftp.includeUbl" component="input" type="checkbox" />{t('delivery.includeUbl')}</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <label htmlFor="notifications.ftp.includeZugferd">
                                                <Field value="notifications.ftp.includeZugferd" name="notifications.ftp.includeZugferd" id="notifications.ftp.includeZugferd" component="input" type="checkbox" />{t('delivery.includeZugferd')}</label>
                                        </div>
                                    </div>
                                </div>}
                                <div className="form-group" style={{marginBottom: 0}}>
                                    <button type="button" style={testBtnStyle} disabled={this.state.testingFtp} onClick={() => this.testFtp()}>
                                        <i className="fa fa-plug"></i>{this.state.testingFtp ? t('delivery.testing') : t('delivery.testConnection')}
                                    </button>
                                    {this.renderTestResult(this.state.ftpResult)}
                                </div>
                            </section>}
                        </div> : <div style={{...cardStyle, opacity: 0.7}}>
                            <h4 style={cardTitleStyle}><i className="fa fa-folder-open" style={{color: 'var(--text-secondary)'}}></i> {t('delivery.ftpBackup')} {upgradeBadge}</h4>
                            <p style={cardDescStyle}>{t('delivery.upgradeFtp')}</p>
                        </div>}

                        {/* Google Drive Section */}
                        {canUseFeature(profile.profile.subscription, 'googleDriveSync') ? <div style={cardStyle}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px'}}>
                                <span style={iconBadgeStyle('#ea4335')}><i className="fa fa-google"></i></span>
                                <div>
                                    <h4 style={{...cardTitleStyle, marginBottom: 0}}>{t('delivery.googleDrive')}</h4>
                                    <p style={{...cardDescStyle, margin: 0}}>{t('delivery.googleDriveDesc')}</p>
                                </div>
                            </div>
                            {google ? <div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', background: '#ecfdf5', borderRadius: '8px', marginBottom: '14px'}}>
                                    <i className="fa fa-check-circle" style={{color: '#059669'}}></i>
                                    <span style={{fontSize: '13px', color: '#065f46', fontWeight: 500}}>{t('delivery.connected')}</span>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'}}>
                                    <button type="button" className="btn btn-default btn-sm" onClick={() => { location.href = '/auth/google/unlink'; }}>{t('delivery.disconnect')}</button>
                                    <button type="button" style={testBtnStyle} disabled={this.state.testingGoogle} onClick={() => this.testGoogleDrive()}>
                                        <i className="fa fa-plug"></i>{this.state.testingGoogle ? t('delivery.testing') : t('delivery.testConnection')}
                                    </button>
                                    {this.renderTestResult(this.state.googleResult)}
                                </div>
                                <p style={{...cardDescStyle, marginTop: '12px', marginBottom: 0}}>
                                    {t('delivery.notWorking')} <a target="_blank" href="https://myaccount.google.com/permissions">{t('delivery.googlePermissions')}</a>, {t('delivery.removeThenReconnect')}
                                </p>
                                {canUseFeature(profile.profile.subscription, 'ublXml') && <div>
                                    {sectionDivider}
                                    <p style={{...cardDescStyle, fontWeight: 500, color: 'var(--text-primary)'}}>{t('delivery.xmlFiles')}</p>
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <label htmlFor="notifications.googleDrive.includeUbl">
                                                <Field value="notifications.googleDrive.includeUbl" name="notifications.googleDrive.includeUbl" id="notifications.googleDrive.includeUbl" component="input" type="checkbox" />{t('delivery.includeUbl')}</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <label htmlFor="notifications.googleDrive.includeZugferd">
                                                <Field value="notifications.googleDrive.includeZugferd" name="notifications.googleDrive.includeZugferd" id="notifications.googleDrive.includeZugferd" component="input" type="checkbox" />{t('delivery.includeZugferd')}</label>
                                        </div>
                                    </div>
                                </div>}
                            </div> : <div>
                                <button type="button" className="btn btn-default" onClick={() => { location.href = '/auth/google'; }}>
                                    <i className="fa fa-google"></i>&nbsp;{t('delivery.connectGoogleDrive')}
                                </button>
                            </div>}
                        </div> : <div style={{...cardStyle, opacity: 0.7}}>
                            <h4 style={cardTitleStyle}><i className="fa fa-google" style={{color: 'var(--text-secondary)'}}></i> {t('delivery.googleDrive')} {upgradeBadge}</h4>
                            <p style={cardDescStyle}>{t('delivery.upgradeGoogleDrive')}</p>
                        </div>}

                        <div style={{height: '80px'}}></div>
                        <div className={pristine ? "save-panel" : "save-panel visible"}>{t('delivery.unsavedChanges')}</div>
                        {!pristine && <button type="button" onClick={() => location.reload()} className="discard-changes-button btn btn-default btn-sm">{t('delivery.discard')}</button>}
                        <button id="save-changes" style={{
                            position: 'fixed',
                            top: '10px',
                            right: '10px',
                            zIndex: '99999999',
                            opacity: pristine ? 0 : 1
                        }} className="btn btn-success btn-sm" type="submit" disabled={pristine || submitting || initialValues.reverting} ><i className="fa fa-check"></i>&nbsp;{t('delivery.save')}</button>
                        <i style={{
                            position: 'fixed',
                            top: '20px',
                            left: '13px',
                            zIndex: '99999997',
                            fontSize: '23px',
                            color: 'white'
                        }} onClick={() => { window.location.href = '/' + this.props.intl.locale + '/dashboard'; }} className="back-button fa fa-arrow-circle-left">&nbsp;</i>
                    </form>
                </div>
            }
        </div>);
    }
}


ProfileForm.PropTypes = {
    onSubmit: PropTypes.func.isRequired,
}

let ProfileFormComponent = reduxForm({ form: "Profile" })(injectIntl(ProfileForm));
ProfileFormComponent = connect(state => {
    const connectors = selector(state, 'connectors');
    const accounting = selector(state, 'accounting');
    const taxes = selector(state, 'taxes');
    const hasMultipleLocations = selector(state, 'hasMultipleLocations');
    const locations = selector(state, 'locations');
    const themes = selector(state, 'themes');
    const google = selector(state, 'google');
    const notifications = selector(state, 'notifications');

    const currentInvoiceDate = selector(state, 'currentInvoiceDate');
    return {
        connectors,
        accounting,
        currentInvoiceDate,
        hasMultipleLocations,
        locations,
        themes,
        taxes,
        google,
        notifications
    }
})(ProfileFormComponent)
const selector = formValueSelector('Profile');

class Profile extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let { dispatch } = this.props;

        dispatch(actions.fetchAccount());
    }

    onSubmit(account) {
        let { dispatch } = this.props;
        dispatch(actions.updateAccount(account));
    }
    render() {

        let { account, intl, profile } = this.props;

        if (!account || !account.email) {
            return <div style={{
                position: 'absolute',
                top: '0',
                left: '50%'
            }}>{intl.formatMessage({ id: 'common.loading' })}</div>
        }

        return <div className="container-fluid">
            <div className="sidebar">
                <div className="col-md-10">
                    <span style={{ marginLeft: '23px' }}>{intl.formatMessage({ id: 'delivery.title' })}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-lg-12 col-xs-12">

                    <ProfileFormComponent onSubmit={this.onSubmit.bind(this)} initialValues={account} profile={profile} />

                </div>
            </div>
        </div>

    }
}

Profile.propTypes = {
    account: PropTypes.object,
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        ...state.user,
        account: {
            ...state.account
        },
        profile: state.form.Profile ? state.form.Profile.values : {},
    };
}

export default injectIntl(connect(mapStateToProps)(Profile));




// WEBPACK FOOTER //
// app/containers/Delivery.jsx